import { createAction } from "@reduxjs/toolkit";

export const logout = createAction("common/logout");
export const refresh = createAction("common/refresh");
export const refreshToken = createAction("common/refreshToken");
